import React, { useMemo } from 'react'
import {
  ActionList,
  ActionListItemProps,
  Avatar,
  Button,
  Highlight,
  Icon,
  useSidePanel,
} from '@node-space/ui-components'
import { Application, CustomerEntityType } from 'types/customers'
import { CustomerSidePanel } from '../CustomerDetails/CustomerSidePanel'
import {
  customerTypeHighlightMap,
  customerTypeLabelMap,
  statusHighlightTypeMap,
  statusLabelMap,
} from '../utils/utils'

export interface ApplicationItemsProps {
  applications: Application[]
}

export const ApplicationItems = ({ applications }: ApplicationItemsProps) => {
  const {
    isSidePanelOpen,
    sidePanelData: selectedApplication,
    paging,
    setIsSidePanelOpen,
    updateSidePanel,
  } = useSidePanel<Application>(applications)

  const onOpenSidePanel = (index: number) => {
    updateSidePanel(index)
    setIsSidePanelOpen(true)
  }

  const items: ActionListItemProps[] = useMemo(
    () =>
      applications?.map(({ id, reference, status, type, name }, index) => ({
        transparent: true,
        key: id,
        id,
        testId: `application-${id}`,
        Avatar: <Avatar type="entity" name={name || reference || id} />,
        title: name || reference || id,
        HeaderHighlightLeft: (
          <Highlight
            iconElement={
              <Icon
                name={type === CustomerEntityType.INDIVIDUAL ? 'UserCircle' : 'BuildingOffice'}
                size="small"
              />
            }
            type={customerTypeHighlightMap[type]}
            variant="emphasis"
          >
            {customerTypeLabelMap[type] ?? type}
          </Highlight>
        ),
        ActionHighlight: (
          <Highlight type={statusHighlightTypeMap[status]}>
            {statusLabelMap[status] ?? status}
          </Highlight>
        ),
        CustomAction: (
          <Button
            variant="ghost"
            iconElement={<Icon name="DotsThreeVerticalCustom" />}
            onClick={() => onOpenSidePanel(index)}
          />
        ),
      })),
    [applications]
  )

  return (
    <>
      <ActionList id="applications-list" items={items} />
      <CustomerSidePanel
        isOpen={isSidePanelOpen}
        application={selectedApplication}
        paging={paging}
        onClose={() => setIsSidePanelOpen(false)}
      />
    </>
  )
}
